var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ru:app"},[_c('nuxt-link',{staticClass:"ru:app__logos",attrs:{"to":_vm.localePath('/')}},[_c('Logo',{attrs:{"variant":_vm.logoVariant}}),_vm._v(" "),(_vm.hasAffiliateLogo)?_c('AffiliateLogo'):_vm._e()],1),_vm._v(" "),(_vm.userDirectoryPerson.firstName)?_c('User'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }